<script>
export default {
  proxy: [],
  current_staffid: "",
  current_roomid: "",  
  widget_accesstoken: "",
  widget_staff: ""  
};
</script>


// WEBPACK FOOTER //
// src/components/Global.vue